import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    selectOnboardingIsRunningState,
    selectOnboardingStep,
    toggleOnBoardingState
} from "../redux/Onboarding"
import { useEffect, useState } from "react"
import OnboardingContents from "../onboarding/OnboardingContents"
import { OnboardingStepOrder } from "../onboarding/OnboardingStep"

function OnboardingBorderLayout() {
    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const dispatch = useAppDispatch()

    const step = useAppSelector(selectOnboardingStep)
    const [progress, setProgress] = useState<number>(0)

    useEffect(() => {
        const percentage = (step / OnboardingStepOrder.length) * 100
        setProgress(Math.trunc(percentage))
    }, [step])

    function leaveOnboarding() {
        dispatch(toggleOnBoardingState())
    }

    return (
        <>
            {onboardingIsRunning && (
                <div
                    className={
                        "fixed flex flex-col top-0 left-0 right-0 bottom-0 border-amber-300"
                    }>
                    <div
                        className={"h-[4px] bg-green-600"}
                        style={{
                            width: `${progress}%`
                        }}></div>
                    <div
                        className={
                            "h-[36px] flex items-center justify-center bg-amber-300"
                        }>
                        <div
                            onClick={leaveOnboarding}
                            className={
                                "ml-auto mr-6 font-bold text-rose-600 tracking-widest cursor-pointer hover:underline hover:text-rose-800"
                            }>
                            Benutzereinführungs-Modus verlassen
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default OnboardingBorderLayout
